import { CSSProperties, FC, ReactNode } from 'react';
import { cva } from 'class-variance-authority';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import { motion } from 'framer-motion';
import Image from 'next/image';

interface Props {
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
  isActive?: boolean;
  onClick?: () => void;
  notFirst?: boolean;
  index: number;
}

export const TabButton: FC<Props> = ({ className, children, style, isActive, onClick, notFirst = true, index }) => {
  return (
    <motion.button
      className={twMergeExt(
        cvaRoot({
          isActive: isActive,
          notFirst: notFirst,
          index: index,
        }),
        className
      )}
      style={style}
      type={'button'}
      onClick={onClick}
    >
      {/* <TabBg className="w-full h-full absolute left-0 bottom-0 bg" />
      <TabIcon className="w-full h-full absolute left-0 bottom-0 bor" /> */}
      {notFirst ? (
        <>
          <div className="absolute bottom-[-1px] w-full h-full">
            <Image fill alt="tab" src="/icons/TabMain.png" />
          </div>
        </>
      ) : (
        <>
          <div className="absolute bottom-[-1px] w-full h-full">
            <Image fill alt="tableft" src="/icons/TabLeft.png" className="" />
          </div>
        </>
      )}
      <span className={'relative'}>{children}</span>
    </motion.button>
  );
};

const cvaRoot = cva(
  [
    'TabButton-cvaRoot',
    'relative',
    'flex justify-center items-center',
    'h-7.5 w-[34.2rem]',
    'text-bodyM',
    'cursor-pointer',
  ],
  {
    variants: {
      isActive: {
        true: ['border-b-0 after:opacity-100'],
        false: ['border-b-0'],
      },
      notFirst: {
        true: ['-ml-4'],
      },
      index: {
        0: ['ml-0'],
        1: ['md:-ml-1 -ml-2'],
        2: ['md:-ml-2 -ml-4'],
        3: ['md:-ml-3 -ml-6'],
        4: ['md:-ml-4 -ml-8'],
      },
    },
  }
);

// const cvaBg = cva([
//   'TabButton-cvaBg',
//   'absolute top-0 left-0',
//   'w-full h-full',
// ]);
